import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthStingService } from '../auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardSign implements CanActivate, CanActivateChild, CanLoad {
    constructor(private _authService: AuthStingService) {}

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        this._check().subscribe();
        return this._check();
    }

    canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._check();
    }

    canLoad(): Observable<boolean> | Promise<boolean> | boolean {
        return this._check();
    }

    private _check(): Observable<boolean> {
        // Check the authentication status
        return this._authService.check().pipe(
            switchMap(() =>
                // Allow the access
                of(true),
            ),
        );
    }
}
